import React from 'react';
import style from './AnalystRecommendations.module.css';
import useUpgradesDowngrades from '../../hooks/useUpgradesDowngrades';

const buyGrades = [
  "Buy",
  "Outperform",
  "Overweight",
  "Strong Buy",
  "Positive",
  "Outperformer",
  "Speculative Buy",
  "Action List Buy",
  "Sector Outperform",
  "Market Outperform",
  "Sector Overweight",
  "Conviction Buy",
  "Accumulate",
  "Top Pick",
  "Above Average",
]

const holdGrades = [
  "Hold",
  "Mixed",
  "Hold Neutral",
  "Neutral",
  "Market Perform",
  "Sector Perform",
  "Perform",
  "Peer Perform",
  "Equal-Weight",
  "Sector Weight",
]

const sellGrades = [
  "Sell",
  "Underperformer",
  "Sector Underperform",
  "Underperform",
  "Underweight",
  "Market Underperform",
  "Below Average",
  "Negative",
  "Reduce",
  "Cautious",
  "Strong Sell",
]

const AnalystRecommendations = ({ stock, showNoDataMessage }) => {
  const { upgradesDowngrades } = useUpgradesDowngrades(stock.id);

  if (!upgradesDowngrades || upgradesDowngrades.length === 0) {
    if (showNoDataMessage) {
      return <p className={style.dimmed}>
        No recommendations in the last 4 months.
      </p>
    }
    return null;
  }

  let buy = 0; let hold = 0; let sell = 0;

  upgradesDowngrades.forEach((item) => {
    if (buyGrades.includes(item.new_grade)) {
      buy = buy + 1;
    }
    if (holdGrades.includes(item.new_grade)) {
      hold = hold + 1;
    }
    if (sellGrades.includes(item.new_grade)) {
      sell = sell + 1;
    }
  })

  if (buy === 0 && hold === 0 && sell === 0) {
    return null
  }
  const total = buy + hold + sell;

  return (
    <div className={style.container}>
      <div className={style.barChart}>
        <div className={style.barBuy} style={{ width: `${buy / total * 100}%` }}></div>
        <div className={style.barHold} style={{ width: `${hold / total * 100}%` }}></div>
        <div className={style.barSell} style={{ width: `${sell / total * 100}%` }}></div>
      </div>
      <div className={style.labels}>
        <div className={style.labelBuy}>
          <span className={style.text}>Buy ({buy})</span>
        </div>
        <div className={style.labelHold}>
          <span className={style.text}>Hold ({hold})</span>
        </div>
        <div className={style.labelSell}>
          <span className={style.text}>Sell ({sell})</span>
        </div>
      </div>
    </div >
  );
};

export default AnalystRecommendations;
